module.exports = __webpack_public_path__ + "static/media/bg-mobile.716d7637.png";